import { useEffect, useState } from "react";
import { Bell, Gift, Coins, Warning, Info } from "@phosphor-icons/react";
import api from "@/lib/api";
import { timeAgo } from "@/lib/format";

const icons = { earn: Coins, redeem: Gift, warning: Warning, info: Info };

export default function CustomerNotifications() {
  const [list, setList] = useState(null);

  useEffect(() => {
    api.get("/customer/notifications").then((r) => setList(r.data)).catch(() => setList([]));
    api.post("/customer/notifications/read").catch(() => {});
  }, []);

  if (!list) return <div className="pt-10 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="pt-2 space-y-4">
      <h1 className="font-display font-bold text-2xl flex items-center gap-2"><Bell size={22} className="text-primary" /> Alerts</h1>
      {list.length === 0 && <p className="text-sm text-muted-foreground">No notifications yet.</p>}
      <div className="space-y-2">
        {list.map((n) => {
          const Icon = icons[n.kind] || Info;
          return (
            <div key={n.id} data-testid="notification-item" className="card-surface p-4 flex gap-3">
              <div className="h-9 w-9 rounded-xl bg-primary/15 flex items-center justify-center shrink-0">
                <Icon size={18} weight="duotone" className="text-primary" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium">{n.title}</p>
                <p className="text-xs text-muted-foreground">{n.body}</p>
                <p className="text-[10px] text-muted-foreground mt-1">{timeAgo(n.created_at)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
